module.exports = __webpack_public_path__ + "static/media/flash-2.b8b30448.mp3";